export default __webpack_public_path__ + "static/media/Group 5.5e00dec7.svg";